import React from 'react'

import { StyledParagraph } from '../../publication/Paragraph/Paragraph.styled'
import { LinkClickedEvent } from '@news-mono/web-common'
import { Intention } from '@news-mono/web-common'

export interface ParagraphProps {
    text: string
    intentions?: Intention[]
    tag?: 'p'
    onEvent: (event: LinkClickedEvent) => void
}

export const Paragraph: React.FC<ParagraphProps> = (props) => {
    return (
        <StyledParagraph
            tag="p"
            text={props.text}
            intentions={props.intentions}
            onEvent={props.onEvent}
        />
    )
}
Paragraph.displayName = 'Paragraph'
